import React from 'react';
import PropTypes from 'prop-types';
import { Experiment, Variant } from '@americanexpress/one-experiments';
import { useMediaBreakpoint } from '@americanexpress/consumer-travel-base';
import { HOMEPAGE_REDESIGN_EXPERIMENT } from '../../constants/experimentConstant';

const TooltipFooter = ({ children }) => {
  const isMobile = useMediaBreakpoint('sm-down');
  const variant = (
    <div>
      <hr className={!isMobile && 'width-auto margin-lr '} />
      <div className="pad-lr pad-b flex-align-center">
        <div className="flex flex-row flex-justify-end margin-2-t">
          {children}
        </div>
      </div>
    </div>
  );
  return (
    <Experiment
      experimentName={HOMEPAGE_REDESIGN_EXPERIMENT}
      dimensionName="search_widget"
      defaultVariant="control"
    >
      <Variant variant="control">
        <div>
          <hr />
          <div className="pad flex flex-row flex-align-center flex-justify-end">
            {children}
          </div>
        </div>
      </Variant>
      <Variant variant="widget_a_with_hero">{variant}</Variant>
      <Variant variant="widget_a_no_hero">{variant}</Variant>
      <Variant variant="widget_b_with_hero">{variant}</Variant>
      <Variant variant="widget_b_no_hero">{variant}</Variant>
    </Experiment>
  );
};

TooltipFooter.propTypes = {
  children: PropTypes.node.isRequired,
};

export default TooltipFooter;
